import { render, staticRenderFns } from "./SelectProductUpsellV2.vue?vue&type=template&id=f46fb270&scoped=true"
import script from "./SelectProductUpsellV2.vue?vue&type=script&lang=js"
export * from "./SelectProductUpsellV2.vue?vue&type=script&lang=js"
import style0 from "./SelectProductUpsellV2.vue?vue&type=style&index=0&id=f46fb270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46fb270",
  null
  
)

export default component.exports